import { useTheme } from "../../contexts/ThemeProvider";
import styled from "styled-components";

const Container = styled.div<any>`
  gap: 2px;
  flex-wrap: wrap;

  img {
    filter: invert(${({ isDark }) => isDark ? '1' : '0'});
  }
`;

function AmenityPreview({ amenity }: any) {
  const { currentTheme } = useTheme();
  return (
    <Container isDark={currentTheme === 'dark'} className="disp-flex h-stack">
      <img src={amenity.icon} width={25} style={{ marginRight: 4 }} /><br/>
      <small>{amenity.name || amenity.code}</small>
    </Container>
  )
}

export default AmenityPreview;
